import React, { useEffect } from 'react';
import { useNotifications } from '../contexts/NotificationContext';

/**
 * Composant qui écoute les événements de notification d'authentification
 * et les affiche via le système de notifications visuelles
 */
const AuthNotificationListener = () => {
  const { addNotification } = useNotifications();

  useEffect(() => {
    const handleAuthNotification = (event) => {
      const { message, type, duration } = event.detail;
      
      // Convertir les types pour le système de notifications
      const notificationData = {
        message,
        type, // 'info', 'success', 'warning', 'error'
        category: 'auth'
      };

      if (duration) {
        notificationData.duration = duration;
      }

      addNotification(notificationData);
    };

    // Écouter les événements d'authentification
    window.addEventListener('auth-notification', handleAuthNotification);

    // Nettoyage lors du démontage
    return () => {
      window.removeEventListener('auth-notification', handleAuthNotification);
    };
  }, [addNotification]);

  // Ce composant n'affiche rien, il ne fait qu'écouter les événements
  return null;
};

export default AuthNotificationListener;